import React from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "../../Hooks/usePagination";
import "./PaginationThree.scss";

const PaginationThree = (props: {
  onPageChange: any;
  totalCount: any;
  siblingCount?: 1 | undefined;
  currentPage: any;
  pageSize: any;
  className: any;
}) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;
  // //Logger("ZZZZZZZZZ00000000000000s", props)
  const paginationRange: any = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange?.length < 1) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  if (currentPage === 0 || paginationRange === undefined) {
    return null;
  }

  const lastPage =
    paginationRange !== undefined
      ? paginationRange[paginationRange?.length - 1]
      : paginationRange[0];

  return (
    <ul className={classnames("paginationThree", { [className]: className })}>
      {/* Left navigation arrow */}
      <li
        className={classnames("pagination-item nav", {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <div className="">Prev</div>
      </li>

 <div className="pagination-center-wrapper">
 <div className="pagination-center">
      {paginationRange.map(
        (pageNumber: any, index: React.Key | null | undefined) => {
          // If the pageItem is a DOT, render the DOTS unicode character
          if (pageNumber === DOTS) {
            return (
              <li className="pagination-item dots" key={index}>
                &#8230;
              </li>
            );
          }
          // Render our Page Pills
          return (
            <li
              key={index}
              className={classnames("pagination-item", {
                selected: pageNumber === currentPage,
              })}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </li>
          );
        },
      )}
      </div>
      </div>

      {/*  Right Navigation arrow */}
      <li
        className={classnames("pagination-item nav", {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        <div className="">Next</div>
      </li>
    </ul>
  );
};

export default PaginationThree;
